import _ from '../../LodashImports';
import {
  CURRENCY_MAPPER,
  formatCommerceDiscountBadge,
  formatCommercePrize,
  formatNumberToPrice,
} from '../../PriceHelpers';

const getCartLineId = (serviceOption, childProducts = []) => {
  const service = childProducts.find((item) => item.variantId === serviceOption.variantId);
  return service && service.cartLineId;
};

const mapWarrantyOptions = (warranty, childProducts, tenant, isSoCom, textDictionary, toggles) => {
  const options = _.get(warranty, 'fieldOptions', []);
  const extendedWarrantyLink = _.get(warranty, 'extendedWarrantyLink', '');
  if (options.length === 0) {
    return undefined;
  }

  let cartLineId = '';
  const mappedFieldOptions = options.map((option) => {
    const id = getCartLineId(option, childProducts);
    if (id) {
      cartLineId = id;
    }
    const { label, price, prices = [], selected, discountBadge } = option;
    const textPrice = label
      ? `${CURRENCY_MAPPER[price.currency] || ''} ${formatNumberToPrice(price.centAmount / price.fraction, tenant)}`
      : '';
    return {
      ...option,
      label: label ? `${label} ${textPrice}` : 'No, gracias',
      textPrice,
      prices: prices?.length > 0 ? formatCommercePrize(prices, tenant, textDictionary, toggles) : undefined,
      discountBadge: discountBadge && formatCommerceDiscountBadge(discountBadge),
      name: label || 'No, gracias',
      selected,
    };
  });

  return {
    defaultText: 'No, gracias',
    fieldName: 'Warranty',
    fieldType: 3,
    label: isSoCom ? 'Extiende tu garantía' : 'Garantía Extendida',
    fieldOptions: mappedFieldOptions,
    extendedWarrantyLink,
    cartLineId,
  };
};

const mapAssemblyOptions = (serviceOptions, childProducts, tenant, isSoCom, textDictionary, toggles) => {
  const options = _.get(serviceOptions, 'fieldOptions', []);

  if (options.length === 0) {
    return undefined;
  }

  const mappedFieldOptions = options
    .filter((option) => option.label)
    .map((option) => {
      let cartLineId = '';
      const id = getCartLineId(option, childProducts);
      if (id) {
        cartLineId = id;
      }
      const { price, label, prices, discountBadge } = option;
      const textPrice = `${CURRENCY_MAPPER[price.currency] || ''} ${formatNumberToPrice(
        price.centAmount / price.fraction,
        tenant
      )}`;
      const mappedOption = {
        ...option,
        label: `${label} ${textPrice}`,
        name: label,
        textPrice,
        prices: prices?.length > 0 ? formatCommercePrize(prices, tenant, textDictionary, toggles) : undefined,
        discountBadge: discountBadge && formatCommerceDiscountBadge(discountBadge),
      };
      if (label) {
        mappedOption.cartLineId = cartLineId;
      }
      return mappedOption;
    });

  return {
    defaultText: 'No, gracias',
    fieldName: '2',
    label: isSoCom ? 'Añade servicios adicionales' : 'Selecciona servicios adicionales',
    fieldOptions: mappedFieldOptions,
  };
};

export const mapProduct = (item, tenant, textDictionary, toggles, isSoCom = false) => {
  const {
    brandName,
    imageUrl,
    name,
    prices,
    productId,
    variantId,
    quantity: qty,
    pdpUrl: link,
    warrantyOptions: warranty,
    serviceOptions,
    cartLineId,
    childProducts,
    offeringId,
    qtyLimits,
  } = item;

  return {
    brandName,
    image: imageUrl,
    name,
    price: formatCommercePrize(prices, tenant, textDictionary, toggles),
    productId,
    skuId: variantId,
    quantity: Number(qty.quantityNumber),
    url: link,
    warrantyOptions: mapWarrantyOptions(warranty, childProducts, tenant, isSoCom, textDictionary, toggles),
    assemblyOptions: mapAssemblyOptions(serviceOptions, childProducts, tenant, isSoCom, textDictionary, toggles),
    totalQuantity: Number(qty.quantityNumber),
    commerceItemId: '',
    cartLineId,
    childProducts,
    offeringId,
    qtyLimits,
  };
};
